import s from './TopPanel.module.scss';

const TopPanel = ({userInfo}) => {
    return (
        <div className={s.top__panel}>
            {userInfo?.userInfo?.name} {userInfo?.userInfo?.surname}
        </div>
    )
}

export default TopPanel